module.exports = __webpack_public_path__ + "img/avatar-mentor-square.5a19d74.svg";